// extracted by mini-css-extract-plugin
export default {"cls1":"AiSummary-cls1___216bc9d6ef0462c9890","cls2":"AiSummary-cls2__bc5323a85f17c4bf23d0 AiSummary-cls1___216bc9d6ef0462c9890"};